import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../ThemeContext';

/* Açık/koyu mod arasında geçiş sağlayan ikon butonu */
export default function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';
  return (
    <button
      type="button"
      className={`theme-toggle ${className}`.trim()}
      onClick={toggleTheme}
      aria-label={isLight ? 'Koyu moda geç' : 'Açık moda geç'}
      title={isLight ? 'Koyu mod' : 'Açık mod'}
    >
      {isLight ? <Moon size={17} /> : <Sun size={17} />}
    </button>
  );
}
